/* eslint-env jquery, browser */
/* global WOW, wistiaJQuery */
import page from 'modules/ab-page-js';
import domify from 'domify';
import load from 'scriptloader';
import rg from 'modules/npm-component/require-global';
import metrics from 'modules/metrics';
import container from 'modules/section-content';
import 'bootstrap';
import Batch from 'batch';
import splash from './customers-page.pug';
import metadata from './metadata.json';
import customers from './customers.json';
import ScrollManager from './js/scroll-manager';

export default function register() {
  page('/customers', render, loadScripts, snippets);
}

function loadScripts(ctx, next) {
  const batch = new Batch();

  batch.push(done => {
    rg('https://cdn.auth0.com/website/assets/pages/customers/resources/jquery-mobile-74ee4c679b.min.js', '$.fn.swiperight', done);
  });

  batch.push(done => {
    rg('//cdnjs.cloudflare.com/ajax/libs/wow/1.0.3/wow.min.js', 'WOW', done);
  });

  batch.push(done => {
    load('//fast.wistia.com/assets/external/popover-v1.js', done);
  });

  batch.push(done => {
    rg('//fast.wistia.com/assets/external/iframe-api-v1.js', 'wistiaApi', done);
  });

  batch.end(next);
}

function snippets(ctx, next) {
  $('body').addClass('loaded');
  let transitioned = 0;

  $('#carousel').swiperight(function() {
    $(this).carousel('prev');
  });

  $('#carousel').swipeleft(function() {
    $(this).carousel('next');
  });

  wistiaJQuery(document).bind('wistia-popover-open', (ev, iframe) => {
    metrics.lib().track('open:video-popup');
  });

  wistiaJQuery(document).bind('wistia-popover', (ev, iframe) => {
    transitioned = 0;
    const api = iframe.wistiaApi;
    api.bind('secondchange', s => {
      transitioned = s;
      if (s && !(s % 10)) {
        // every 10 seconds, we trigger a length event
        metrics.lib().track('viewed:video-length', { value: transitioned });
      }
    });
    api.bind('play', () => {
      metrics.lib().track('click:video-play', { value: transitioned });
    });
    api.bind('pause', () => {
      metrics.lib().track('click:video-pause', { value: transitioned });
    });
  });

  wistiaJQuery(document).bind('wistia-popover-close', () => {
    $('.banner .container h1, .banner .container p')
      .removeClass('animated fadeOutUp')
      .addClass('animated fadeInDown');
    $('.banner .container a')
      .removeClass('animated fadeOutDown')
      .addClass('animated fadeInUp');
    metrics.lib().track('close:video-popup', { value: transitioned });
    transitioned = 0;
  });

  const newScrollManager = new ScrollManager();
  newScrollManager.init();

  $('.nav-categories li').click(function() {
    $('.nav-categories li').removeClass('active');
    $(this).addClass('active');
    const linkCategory = $(this).attr('data-category');
    if (linkCategory == 'all') {
      $('.customers-gallery-container .customer-container').each(function() {
        $(this).show();
      });
      return;
    }
    $('.customers-gallery-container .customer-container').each(function() {
      if ($(this).filter(`[data-category *= ${linkCategory}]`).length) {
        $(this).show();
        return;
      }
      $(this).hide();
    });
  });

  $('#search-input').on('keyup', function() {
    const searchVal = $(this)
      .val()
      .toLowerCase();
    $('.customers-gallery-container .customer-container').each(function() {
      if ($(this).filter(`[data-search *= ${searchVal}]`).length > 0 || searchVal.length < 1) {
        $(this).show();
        return;
      }
      $(this).hide();
    });
  });

  next();
}

function render(ctx, next) {
  const view = domify(splash({ customers }));
  const renderOptions = {
    metadata,
    // Only pass view on client render.
    ...(ctx.init ? {} : { view })
  };
  container.render(renderOptions);

  if (window.location.hash) {
    const highlightedElement = $(window.location.hash);
    if (highlightedElement.length <= 0) return; // Check if the highlighted id is in the dom
    $(window).scrollTop($(highlightedElement).offset().top - 100);
  }

  next();
}



// WEBPACK FOOTER //
// ./src/pages/customers/customers.js